'use strict';

// OBSOLETE

const { pubdb } = Function('return this')();
const { window, $, encode_uri_component } = pubdb;
const { location, setTimeout, JSON } = window;
const { parse } = JSON;

const [/*omit*/, datum_type, datum_id ] = /[/]([^/]+)[/](\d+)(?:-[^/]*)?(?:[/]|[.][^/]+)$/.exec(location.pathname);

let shared_csrf_token;


const lz_div_owners = (function () {
    function input_enter () {
        const value = pubdb.trim(input.val());
        if (!value) {
            return;
        }

        function success ({ success, reason, owner, existed }) {
            if (!success) {
                pubdb.echo('error', `Bearbeiter konnte nicht hinzugefügt werden: ${reason}`);
            } else if (existed) {
                pubdb.echo('confirm', 'Der Bearbeiter war bereits in der Liste. Er wurde nicht doppelt eingefügt.');
            } else {
                input.val('');
                format_owner(owner);
            }
        }

        rpc('add_owner', value, success);
    }

    const cache = Object.create(null);

    const input = $('<input/>', {
        attr: {
            type: 'text',
            value: pubdb.login_details.account_name,
            style: 'display:inline-block; width:calc(100% - 40px - 1em)',
        },
        on: {
            keypress (ev) {
                let { which } = ev;
                if (which === 10 || which === 13) {
                    ev.preventDefault();
                    input_enter();
                }
            },
            focus (ev) {
                setTimeout((self) => { self.select(); }, 0, this);
            },
        },
    });

    setTimeout(function () { input.autocomplete({
        source (request, response) {
            const { term } = request;

            function success (data) {
                if (typeof data === 'string') {
                    data = parse(data);
                }

                cache[term] = data;
                response([].map.call(data, function (value) {
                    const { id, forename, surname, account_name } = value;
                    const label = `${surname}, ${forename} (${account_name})`;
                    value.label = label;
                    value.toString = () => label;
                    return { value, label };
                }));
            }

            function error () {
                response([]);
            }

            const cached_value = cache[term];
            if (cached_value != null) {
                success(cached_value);
            } else {
                pubdb.ajax_get(
                    `${pubdb.path_root}/user/autocomplete/reviewer/?q=${encode_uri_component(term)}`,
                    success, error, false, true,
                );
            }
        },
        select (ev, ui) {
            setTimeout(function (name) {
                input.val(name);
                input_enter();
            }, 0, ui.item.value.account_name);
            return false;
        },
        open () {
            $(this).removeClass('ui-corner-all').addClass('ui-corner-top');
        },
        close () {
            $(this).addClass('ui-corner-all').removeClass('ui-corner-top');
        },
        minLenght: 1,
        delay: 100,
    }); }, 0);

    const lz_div_owners = $('<ul/>', {
        append: [
            $('<li/>', {
                append: $('<label/>', {
                    text: '＋',
                    style: 'margin:0; font-weight:normal',
                    append: input,
                }),
            }),
        ],
    });

    return lz_div_owners;
} ());


function lz_div_review_li (cb, text) {
    let old_value = null;

    function change (ev) {
        const new_value = !!input.prop('checked');
        if (old_value === null) {
            old_value = !new_value;
        } else if (new_value === old_value) {
            return;
        }

        ev.preventDefault();

        function success ({ success, reason, check }) {
            if (!success) {
                pubdb.echo('error', `Markierung konnte nicht geändert werden: ${reason}`);
                return;
            }

            if (check) {
                pubdb.echo('confirm', 'Markierung wurde hinzugefügt');
                format_check(check);
                old_value = true;
            } else {
                pubdb.echo('confirm', 'Markierung wurde entfernt');
                $('>div', p).remove();
                old_value = false;
            }

            input.prop('checked', old_value);
        }

        rpc(new_value ? 'set_check' : 'del_check', cb, success);
    }

    const input = $('<input/>', {
        attr: {
            'data-cb': cb,
            style: 'display:inline-block; width:unset; margin:0',
        },
        type: 'checkbox',
    }).on('change blur click', change);

    const p = $('<p/>', {
        append: $('<label/>', {
            attr: { style: 'margin:0; font-weight:normal' },
            text,
            prepend: input,
        }),
    });

    return $('<li/>', {
        attr: { 'data-cb': cb },
        append: p,
    });
}

const lz_div_review = $('<ul/>', {
    append: ({
        pub () {
            return [
                lz_div_review_li('sep_doing', ' SEP: in Bearbeitung'),
                lz_div_review_li('sep_done', ' SEP: erledigt'),
            ];
        },
    }[datum_type] || (() => $('<li/>', { text: `keine bekannt für ${datum_type} (?)` })))(),
});


function format_check ({ type, reviewer, ts }) {
    const li = $(`li[data-cb="${type}"]`, lz_div_review);
    $('input', li).prop('checked', true);
    small_user(ts, reviewer).appendTo($('>p', li));
}


const lz_div_message = $('<textarea>', {
    attr: {
        style: 'display:inline-block; width:calc(100% - 40px)',
    },
});


const lz_div = $('<form/>', {
    attr: {
        action: 'javascript:;',
        style: 'font-size:90%; padding:0; margin:0',
    },
    on: {
        submit (ev) {
            ev.preventDefault();
        },
    },
    append: [
        $('<div/>', { append: [
            $('<h3/>', {
                text: 'Zugewiesene(r) Bearbeiter:',
                attr: { style: 'font-size:120%; line-height:1em' },
            }),
            lz_div_owners,
        ] }),
        $('<div/>', { append: [
            $('<h3/>', {
                text: '(Interne) Bemerkung(en):',
                attr: { style: 'font-size:120%; line-height:1em' },
            }),
            $('<ul/>', { append: $('<li/>', { append: lz_div_message }) }),
        ] }),
        $('<div/>', { append: [
            $('<h3/>', {
                text: 'Gesetzte Markierungen:',
                attr: { style: 'font-size:120%; line-height:1em' },
            }),
            lz_div_review,
        ] }),
    ],
});


function rpc (op, value, complete) {
    function success (response) {
        if (!response) {
            response = {};
        }

        const { csrf_token } = response;
        if (csrf_token) {
            shared_csrf_token = csrf_token;
        }

        complete(response);
    }

    pubdb.ajax_post(
        `${pubdb.path_root}/laufzettel/save/`,
        { datum_id, datum_type, op, value, csrf_token: shared_csrf_token },
        success,
        success,
    );
}


function format_owner ({ owner, creator, date }) {
    function click (ev) {
        ev.preventDefault();

        function success ({ success, reason }) {
            if (!success) {
                pubdb.echo('error', `Bearbeiter konnte nicht gelöscht werden: ${reason}`);
            } else {
                row.remove();
            }
        }

        rpc('del_owner', owner.id, success);
    }

    const row = $('<li/>', {
        append: [
            $('<div/>', {
                text: ' ',
                prepend: $('<a/>', {
                    attr: { href: `${pubdb.path_root}/user/${owner.id}/`, target: '_blank' },
                    text: owner.account_name,
                }),
                append: $('<a/>', {
                    attr: {
                        class: 'ui-state-default ui-corner-all',
                        href: 'javascript:;',
                        role: 'button',
                        style: 'padding:1pt 2pt 0 2pt',
                    },
                    on: { click },
                    append: $('<span/>', {
                        attr: {
                            class: 'ui-icon ui-icon-closethick',
                            style: 'display:inline-block',
                        },
                        text: 'entfernen',
                    }),
                }),
            }),
            small_user(date, creator),
        ],
        appendTo: lz_div_owners,
    });

    return row;
}


function small_user (date, user) {
    const { id, account_name } = user;
    return $('<div/>', {
        append: $('<small/>', {
            text: ` um ${pubdb.date_berlin(true, date)}`,
            prepend: $('<a/>', {
                attr: { href: `${pubdb.path_root}/user/${id}/`, target: '_blank' },
                text: account_name,
            }),
        }),
    });
}


false && // disable!
pubdb.ajax_post(`${pubdb.path_root}/laufzettel/${datum_type}/${datum_id}/`, null, function (response) {
    const { success, reason, lz, datum, message, checks, csrf_token } = response || {};
    if (csrf_token) {
        shared_csrf_token = csrf_token;
    }
    if (!success) {
        pubdb.echo('error', `Laufzettel konnte nicht geladen werden: ${reason}`);
        return;
    }

    const { owners } = lz || {};

    [].forEach.call(owners || {}, format_owner);
    [].forEach.call(checks || {}, format_check);

    if (message !== null) {
        lz_div_message.val(message);
    } else {
        lz_div_message.val('<nicht möglich>').prop({enabled: false, readonly: true});
    }

    pubdb.resizable_dialog(lz_div, {
        width: 800,
        height: 600,
        title: 'Laufzettel',
    });
});
